/** Full backend URL from REACT_APP_API_BASE_URL (e.g. http://localhost:8000/api). */


export const API_CONFIG = {
  
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  ASSET_BASE_URL: process.env.REACT_APP_ASSET_URL,
  TIMEOUT: 50000,

  ENDPOINTS: {
    LOGIN: "/familyLogin",
    VERIFY: "/familyMe",
    REGISTER: "/register",
    SET_PASSWORD: "/setPassword",
    REQUEST_RESET: "/requestPasswordReset",
    CENTRES: "/getActiveCentres",
    PORTAL_SETTINGS: "/getPortalSettings",

    HANDBOOK: "/familyHandbook",
    FORMS: "/familyForms",
    DOCUMENTS: "/familyDocuments",
    POLICIES: "/familyPolicies",
    CHILDREN: "/familyChildren",
    SUBMISSIONS: "/familySubmissions",
    HOLIDAY_BALANCE: "/familyHolidayBalance",
    SUBMIT_FORM: "/familySubmitForm",
    UPDATE_PROFILE: "/familyUpdateProfile",
    CHANGE_PASSWORD: "/familyChangePassword",
    NOTIFICATIONS: "/familyNotifications",
    UPDATE_NOTIFICATIONS: "/familyUpdateNotifications",
  },
};

export const fileUrl = (path) =>
  path ? API_CONFIG.ASSET_BASE_URL + "uploads/" + String(path).replace(/^uploads\//, "") : null;
